import React from "react";
import styles from "./styles.module.scss";

export default function SubmitWrapper({ children }) {
  return <div className={styles.submitWrapper}>{children}</div>;
}
